import React from "react";

const BS5_Typography = () => {
  return (
    <div className="container mt-4">
      <h2>BS5_Typography Component</h2>
      <p>This is the BS5_Typography component for Bootstrap 5 tutorial.</p>
    </div>
  );
};

export default BS5_Typography;
